import { flexRender, Table as TanTable } from '@tanstack/react-table';
import { useRef } from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import styles from './AppTable.module.scss';
import clsx from 'clsx';

// ignored because it's used in react-table as well
// eslint-disable-next-line @typescript-eslint/ban-types
export function AppTable<D extends object = object>(props: {
  table: TanTable<D>;
  classes?: {
    wrapper?: string;
    table?: string;
    cell?: string;
    header?: string;
  };
}) {
  const { table } = props;
  const tableRef = useRef<HTMLDivElement>(null);
  return (
    <TableContainer
      ref={tableRef}
      component={Paper}
      className={props.classes?.wrapper}
    >
      <Table
        stickyHeader
        aria-label="sticky table"
        className={props.classes?.table}
      >
        <TableHead>
          {table.getHeaderGroups().map((headerGroup) => (
            <TableRow key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <TableCell
                  key={header.id}
                  {...{
                    className: clsx(
                      header.column.getCanSort()
                        ? styles.sortableColumnHeader
                        : undefined,
                      props.classes?.header,
                    ),
                    onClick: header.column.getToggleSortingHandler(),
                  }}
                  style={{ width: header.column.getSize() }}
                >
                  <>
                    {flexRender(
                      header.column.columnDef.header,
                      header.getContext(),
                    )}
                    {{
                      asc: ' 🔼',
                      desc: ' 🔽',
                    }[header.column.getIsSorted() as string] ?? null}
                  </>
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableHead>
        <TableBody>
          {table.getRowModel().rows.map((row) => {
            return (
              <TableRow key={row.id}>
                {row.getVisibleCells().map((cell) => {
                  return (
                    <TableCell key={cell.id} className={props.classes?.cell}>
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext(),
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
